import {
  UserGroupIcon,
  ClockIcon,
  EyeDropperIcon,
  MagnifyingGlassIcon,
  AcademicCapIcon,
  FaceSmileIcon,
  PhoneIcon,
  PrinterIcon,
  EnvelopeIcon,
  SparklesIcon,
  CloudIcon,
  ArrowDownIcon,
  CogIcon,
  PaintBrushIcon,
  CameraIcon,
  CheckCircleIcon,
  DocumentIcon
} from "@heroicons/react/24/solid";

import benefitOneImg from "../img/benefit-one.png";

// Blend pictures
import blend1 from "../img/manufacture/blend/blend1.jpg";
import blend2 from "../img/manufacture/blend/blend2.jpg";
import blend3 from "../img/manufacture/blend/blend3.jpg";

// Capsule pictures
import capsuling1 from "../img/manufacture/capsule/capsuling1.jpg";
import capsuling2 from "../img/manufacture/capsule/capsuling2.jpg";
import capsuling3 from "../img/manufacture/capsule/capsuling3.jpg";

//Tablet pictures
import tabletting1 from "../img/manufacture/tablet/tabletting1.jpg";
import tabletting2 from "../img/manufacture/tablet/tabletting2.jpg";
import tabletting3 from "../img/manufacture/tablet/tabletting3.jpg";

//Blister pictures
import blister2 from "../img/conditionning/blister/blister2.jpg";
import blister3 from "../img/conditionning/blister/blister3.jpg";

//Pot pictures
import pot1 from "../img/conditionning/pot/pot1.jpg";
import pot2 from "../img/conditionning/pot/pot2.jpg";

//Powder pictures
import powder1 from "../img/conditionning/powder/powder1.jpg";
import powder2 from "../img/conditionning/powder/powder2.jpg";

//Contact
import plan from "../img/plan.jpg";

//NotFound pictures
import notFound1 from "../img/notFound/notFound1.png";
import notFound2 from "../img/notFound/notFound2.png";
import notFound3 from "../img/notFound/notFound3.png";

const dataEN = {
  navigation: [
    {
      href: "/",
      label: "Home",
    },
    {
      href: "/manufacture",
      label: "Manufacture",
    },
    {
      href: "/conditionning",
      label: "Conditionning",
    },
    {
      href: "/quality",
      label: "Quality",
    },
    {
      href: "/contact",
      label: "Contact",
    },
  ],
  home: {
    preTitle: "The Benefits of Pharma Manufacturing",
    title: "Expertise & Quality",
    desc: (
    <>
    Custom manufacturing of dietary supplements according to <span className="text-green-500">GMP</span> standards and <span className="text-green-500">FSSC22000</span> certification. <br/>
    Pharmaceutical expertise since <span className="font-bold">1988</span>.<br/>
    Quality guaranteed by professionals including <span className="font-bold"><span className="text-green-500">3</span> pharmacists</span> and <span className="font-bold">state-of-the-art equipment.</span>
    </>
    ),
  },
  hero: {
    eyebrow: "Pharmaceutical expertise",
    sinceLabel: "Since",
    title: "Pharma Manufacturing",
    desc: ( 
      <> 
        For over 30 years, our pharmaceutical expertise has been serving your well-being. <br/>State-of-the-art equipment for production in compliance with the strictest standards.
      </>
    ),
    subDesc: (
      <>
        A fleet of <span className="text-green-500">over 50</span> machines to meet all your projects.
      </>
    ),
    calloutLabel: "Production",
    calloutText: "More than 50 machines to support all your projects.",
  },
  benefitOne: {
    title: "Expertise",
    desc: "Pharma Manufacturing offers you the assurance of unique know-how. With decades of experience, our multidisciplinary team of pharmacists and dietitians provides you with specialized expertise in the formulation and production of dietary supplements. From design to realization, we accompany you in all your projects.",
    image: benefitOneImg,
    bullet: true,
    bullets: [
      {
        title: "Multidisciplinary Team",
        desc: "Composed of an Industrial Pharmacist, pharmacists, and a dietitian",
        icon: <UserGroupIcon />,
      },
      {
        title: "Proven Experience",
        desc: "Since 1988",
        icon: <ClockIcon />,
      },
      {
        title: "Mastery of Standards",
        desc: "FSSC2200, BIO",
        icon: <AcademicCapIcon />,
      },
    ],
  },
  manufacture: {
    preTitle: "The Art of Manufacturing",
    title: "Manufacturing",
  },
  notification: {
    preTitle: "The Art of Manufacturing",
    title: "Manufacturing",
  },
  blend: {
    title: "Blending",
    desc: "With several blenders of all sizes, including planetary and tumbler types, Pharma Manufacturing guarantees the homogeneity of your blends for both small and large quantities.",
    desc2: "",
    desc3: "",
    images: [blend1, blend2, blend3],
    bullet: false,
    bullets: [
      {
        title: "Pure Products",
        desc: "Careful and controlled manufacturing",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Pure Products",
        desc: "Careful and controlled manufacturing",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Customer Satisfaction",
        desc: "Proven efficiency and trust",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  capsule: {
    title: "Capsules",
    desc: "With 5 capsule machines of various capacities in sizes 00, 0, 1, Pharma Manufacturing can easily handle the production of any volume from 50,000 capsules.",
    desc2: "",
    images: [capsuling1, capsuling2, capsuling3],
    bullet: true,
    bullets: [
      {
        title: "Polishing",
        desc: "",
        icon: <SparklesIcon />,
      },
      {
        title: "Dusting",
        desc: "",
        icon: <CloudIcon />,
      },
    ],
  },
  tablet: {
    title: "Tablets",
    desc: "With 2 versatile tablet presses featuring pre-compression, Pharma Manufacturing can produce tablets of all sizes up to 23 mm and in all desired shapes, including round and pill shapes, as well as oblong tablets holding up to one and a half grams of active ingredient.",
    desc2:"",
    images: [tabletting1, tabletting2, tabletting3],
    bullet: true,
    bullets: [
      {
        title: "Direct Compression",
        desc: "The powder is directly compressed after mixing",
        icon: <ArrowDownIcon />,
      },
      {
        title: "Compression After Granulation",
        desc: "During blending, some ingredients are granulated for better compression",
        icon: <CogIcon />,
      },
      {
        title: "Coating",
        desc: "After compression, we can coat the tablets",
        icon: <PaintBrushIcon />,
      },
    ],
  },
  conditionning: {
    preTitle: "Always an option for your products",
    title: "Packaging",
  },
  blister: {
    title: "Blistering",
    desc: "Equipped with 5 blister machines and a cartoner, Pharma Manufacturing has high daily capacity to provide you with products in the shortest possible time.",
    desc2:"",
    desc3: "",
    images: [blister2, blister3],
    bullet: true,
    bullets: [
      {
        title: "Camera",
        desc: "A camera inspects defects and ejects non-conforming blisters",
        icon: <CameraIcon />,
      },
      {
        title: "Automatic Cartoner Control",
        desc: "The machine performs an automatic check to verify the correct number of blisters is in the carton",
        icon: <CheckCircleIcon />,
      },
      {
        title: "Presence of Instruction Leaflet",
        desc: "The automatic control also checks if the leaflet is present in the carton",
        icon: <DocumentIcon />,
      },
    ],
  },
  powder: {
    title: "Powders",
    desc: "Packaging of dietary powders in pots or buckets of small or large volume.",
    desc2: "",
    desc3: "",
    images: [powder1, powder2],
    bullet: false,
    bullets: [
      {
        title: "Rigorous Control",
        desc: "Compliance with various followed certifications",
        icon: <MagnifyingGlassIcon />,
      },
      {
        title: "Pure Products",
        desc: "Careful and controlled manufacturing",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Customer Satisfaction",
        desc: "Proven efficiency and trust",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  pot: {
    title: "Bottling",
    desc: "With an optical counter and a labeling machine, Pharma Manufacturing can bottle tablets and capsules of any size and label them.",
    desc2: "",
    desc3: "",
    images: [pot1, pot2],
    bullet: false,
    bullets: [
      {
        title: "Rigorous Control",
        desc: "Compliance with various followed certifications",
        icon: <MagnifyingGlassIcon />,
      },
      {
        title: "Pure Products",
        desc: "Careful and controlled manufacturing",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Customer Satisfaction",
        desc: "Proven efficiency and trust",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  quality: {
    title: "Quality",
    desc: "Permanent quality control by our industrial pharmacist, our two pharmacists, and their team:",
    controlList: [
      "Control and weighing of delivered raw materials",
      "Mixing control and verification of the total weight obtained",
      "Individual weighing of tablets and capsules during production",
      "Hardness, disintegration, and friability testing of tablets",
      "Blister sealing test",
      "Production validation by the responsible pharmacist",
      "Preparation of manufacturing files adhering to GMP (traceability of manufacturing and packaging operations)",
      "Compliance with current good manufacturing practices (GMP), as well as HACCP and FSSC22000 standards",
      "Material flow procedures in the manufacturing area and adherence to FIFO (first in, first out) during weighing",
      "Work described by standard operating procedures (SOPs)",
      "Cold storage for conserving, among others, probiotics before and immediately after production to ensure product quality",
    ],
  },
  contact: {
    title: "Contact",
    desc: (
      <>
        <span className="text-green-500 font-bold uppercase">
          Pharma Manufacturing
        </span>
        <br></br>
        Créalys Scientific Park <br></br>
        Rue Guillaume Fouquet, 16<br></br>
        5032 ISNES
      </>
    ),
    desc2: "",
    desc3: "",
    image: plan,
    imageFrame: false,
    bullets: [
      {
        title: "Phone",
        desc: "+ 32 (0) 81/73.55.81",
        icon: <PhoneIcon />,
      },
      {
        title: "Fax",
        desc: "+ 32 (0) 81/73.55.61",
        icon: <PrinterIcon />,
      },
      {
        title: "E-Mail",
        desc: (
          <>
            <a href="mailto:pharma.manufacturing@gmail.com">
              <span className="text-green-500">pharma.manufacturing@gmail.com</span>
            </a>
          </>
        ),
        icon: <EnvelopeIcon />,
      },
    ],
  },
  notFound: {
    title: "Looks like you've found the doorway to the great nothing",
    desc: "The content you’re looking for doesn’t exist. Either it was removed, or you mistyped the link.",
    desc2: "Sorry about that! Please visit our homepage to get where you need to go.",
    desc3: "Go back to homepage",
    images: [notFound1, notFound2, notFound3],
    bullet: false,
    bullets: [
      {
        title: "",
        desc: "",
        icon: "",
      },
      {
        title: "",
        desc: "",
        icon: "",
      },
      {
        title: "",
        desc: "",
        icon: "",
      },
    ],
  },
};


export { dataEN };
